import { OpenChatButton } from "components/OpenChatButton";
import type { OpenChatButtonProps } from "components/OpenChatButton";
import type { ReactStoryblokComponent } from "types/storyblok";

const OpenChatButtonAdapter = ({
  blok: { icon, buttonText },
  sbEditable,
}: ReactStoryblokComponent<OpenChatButtonProps>) => (
  <OpenChatButton icon={icon} buttonText={buttonText} sbEditable={sbEditable} />
);

export default OpenChatButtonAdapter;
